export const AdelphiTheatre = {
  basketNote: {},
  colors: {
    venueLogoBackgroundColor: '#f27e78'
  },
  themeVenueLogo: 'adelphi_sw_icon.png',
  themeVenueName: 'Adelphi Theatre',
  themeVenueAddress: '409-412 Strand, London WC2R 0NS'
}
